import React from 'react';
import ContentLoader from "react-content-loader";
import { PRODUCT_GOLD_TYPE_NAME_INITIAL } from '../../../../constants';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import ProfitLossFormat from '../../../../components/currencyFormat/ProfitLossFormat';
import { updateCompanyDashboardAction } from '../../../../actions/companyDashboard';
import moment from 'moment';

export default function CompanyProfileLoss({ setIsEditing }) {
    const {
        handleSubmit,
    } = useForm();
    const dispatch = useDispatch()
    const { companyProfitAndLoss, isCompanyDashboardProfitLossLoading } = useSelector((state) => state.companyDashboard);
    const { isAdminLoggedIn } = useSelector((state) => state.auth);

    const onSubmit = (data) => {
        let Payload = {
            profitLoss: {
                asOf: data.asOfDateTime,
                ytd: data.PLytd,
                allocation: data.PLAllocation
            }
        }
        dispatch(updateCompanyDashboardAction(Payload))
        setIsEditing(null);
    };
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='accountBorderSection'>

                    {isCompanyDashboardProfitLossLoading ? (
                        <div className='row cashHederSection cashHederSectionPadding'>
                            <div className='col-md-12'>
                                <div style={{ width: '100%', marginLeft: 'auto' }}>
                                    <ContentLoader width="100%" height={15}>
                                        <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                    </ContentLoader>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='row cashHederSection cashHederSectionPadding'>
                            <div className='col-12 justifySection'>
                                <h6 className='cashHeaderText cashDarkText m-0'>Profit/Loss  <span className="asof">(as of {moment().format("DD/MM/YYYY")})</span></h6>
                                {isAdminLoggedIn && (
                                    <span className="btn btn-link  px-3 mb-0 edit-button faded-edit"></span>
                                )}
                            </div>
                        </div>
                    )}

                    <div className='col-12'><hr className='m-0'></hr></div>

                    <div className='cashBottomPadding'>
                        <div className='row'>
                            <div className='col-4'><p className='accountPrimaryText'>Product name</p></div>
                            <div className='col-4'><p className='accountPrimaryText'>Weight</p></div>
                            <div className='col-4 rightAlignText'><p className='accountPrimaryText'>Profit/Loss</p></div>
                        </div>

                        {isCompanyDashboardProfitLossLoading ? (
                            <div className='row'>
                                <div className='col-12 currentBalanceDetails'>
                                    <ContentLoader width="100%" height={15}>
                                        <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                                    </ContentLoader>
                                </div>
                            </div>
                        ) : (
                            companyProfitAndLoss?.profitLossData?.map((item, index) => (
                                <div key={index} className='row pb-2'>
                                    <div className='col-4'>
                                        <h6 className='accountSecondaryText'>{item?.allocation || "-"}</h6>
                                    </div>
                                    <div className='col-4'>
                                        <h6 className='accountSecondaryText'>{item?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM ? item?.totalGram : item?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM ? item?.totalKilogram : item?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.OUNCE ? item?.totalOunce : '-'} {item?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM ? "gram" : item?.type || "-"}</h6>
                                    </div>
                                    <div className='col-4 rightAlignText'>
                                        <h6 className='accountSecondaryText'>{item?.convertionCurrency}&nbsp;
                                            {item?.ytd === '-' ? ("") : (
                                                <ProfitLossFormat currency={item?.convertionCurrency} value={parseFloat(item?.ytd)} decimal={2} />
                                            )}
                                        </h6>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </form>
        </>
    )
}
